import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class DepartmentService {

    static getDepartmentListResult(CompanyCode, list, ActionType) {

        var data={
            CompanyCode: CompanyCode,
            list: list,
            ActionType:ActionType
        }  
        return axios.post(BaseUrl+ 'Department', data);
    }

    static SaveDepartment(CompanyCode, list, ActionType, email) {

        var data={
            CompanyCode: CompanyCode,
            list: list,
            ActionType:ActionType
        }  
        return axios.post(BaseUrl+'SaveDepartment?email='+email, data);
    }
}


// WEBPACK FOOTER //
// ./src/Services/Department/departmentService.js